import {
  ManufacturerSearchField,
  ManufacturerSearchParams,
  ManufacturerSortField,
} from '../models/manufacturer-search.model'
import {
  QueryStringFilter,
  QueryStringSort,
} from '../../../models/query-string.model'
import { parseFilters } from '../../../libs/filter.lib'

export function parseManufacturerFilters(
  params: ManufacturerSearchParams,
  filters: ManufacturerSearchParams,
): ManufacturerSearchParams {
  return parseFilters(params, filters, manufacturerFilterParams)
}

export function manufacturerSortParams(
  params: ManufacturerSearchParams,
  sort: QueryStringSort<ManufacturerSortField>,
): ManufacturerSearchParams {
  const searchParams: ManufacturerSearchParams = {}

  switch (sort.field) {
    case 'name':
      searchParams.sort = 'name'
      searchParams.order = sort.order
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

export function manufacturerFilterParams(
  params: ManufacturerSearchParams,
  filter: QueryStringFilter<ManufacturerSearchField>,
): ManufacturerSearchParams {
  const searchParams: ManufacturerSearchParams = {}

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams._id = filter.value
      }
      break
    case 'name':
      if (filter.operator === '=') {
        searchParams.name = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['name:ct'] = filter.value
      }
      break
    case 'externalId':
      if (filter.operator === '=') {
        searchParams.externalId = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['externalId:ct'] = filter.value
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
